<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">Compliance &amp; Protection</h1>

        <section class="content-section">
            <p class="desc-text">XigCheck is designed to support marketplace trust, product transparency, and platform integrity through structured authentication review procedures and marketplace risk-control policies.</p>
            <p class="desc-text">XigCheck does not operate as a financial institution, escrow provider, payment processor, investment platform, digital wallet, or cryptocurrency-related service provider.</p>
        </section>

        <div class="policy-actions" aria-label="Compliance and protection policies">
            <router-link to="/xigcheck/fraud-prevention" class="policy-action">Fraud prevention <span class="action-arrow">&gt;</span></router-link>
            <router-link to="/xigcheck/independent-review" class="policy-action">Independent review <span class="action-arrow">&gt;</span></router-link>
            <router-link to="/xigcheck/no-escrow" class="policy-action">No escrow <span class="action-arrow">&gt;</span></router-link>
            <router-link to="/xigcheck/no-financial-services" class="policy-action">No financial services <span class="action-arrow">&gt;</span></router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'XigcheckComplianceProtection'
}
</script>

<style scoped>
@import './xigcheck-doc.css';

.policy-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 22px;
    margin-top: 42px;
}
.policy-action {
    border: 0;
    background: transparent;
    color: #ff5e3f;
    cursor: pointer;
    font-family: 'Poppins', Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.4;
    padding: 0;
    text-decoration: none;
}
.action-arrow {
    display: inline-block;
    font-size: 32px;
    font-weight: 600;
    line-height: 1;
    margin-left: 10px;
    transform: translateY(2px);
}

@media (max-width: 900px) {
    .policy-actions {
        gap: 12px;
        margin-top: 24px;
    }
    .policy-action {
        font-size: 11px;
    }
    .action-arrow {
        font-size: 20px;
        margin-left: 6px;
        transform: translateY(1px);
    }
}
</style>
